// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S8lq","col":"styles_col__3DE-N"};